"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExportReport = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var dropdownOnChange_1 = require("utils/helpers/dropdownOnChange");
var timezones_1 = require("utils/helpers/timezones");
var user_1 = require("utils/selectors/user");
var LanguageSelect_1 = require("../LanguageSelect");
var TimezoneSelect_1 = require("../TimezoneSelect");
var Export_1 = require("./components/Export");
var dispatchers_1 = require("./utils/dispatchers");
var ExportReport = function (_a) {
    var customerId = _a.customerId, templateUuid = _a.templateUuid, disabled = _a.disabled, onExport = _a.onExport;
    var userLanguage = (0, react_redux_1.useSelector)(user_1.selectUserLanguage);
    var dispatchers = (0, dispatchers_1.mapDispatchers)((0, react_redux_1.useDispatch)());
    var _b = React.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = React.useState(), language = _c[0], setLanguage = _c[1];
    var _d = React.useState(), timezone = _d[0], setTimezone = _d[1];
    var exportAction = function () {
        dispatchers.exportReport({
            customerId: customerId,
            templateUuid: templateUuid,
            language: language === null || language === void 0 ? void 0 : language.code,
            timezone: timezone === null || timezone === void 0 ? void 0 : timezone.value
        });
        setIsOpen(false);
        onExport();
    };
    React.useEffect(function () {
        setLanguage(userLanguage);
        setTimezone((0, timezones_1.getLocalTimezone)());
    }, [isOpen]);
    return (React.createElement("div", { className: 'export-button-group' },
        React.createElement(Export_1.Export, { size: 'large', onClick: exportAction, disabled: disabled }),
        React.createElement(sok_ui_1.Dropdown2, { isOpen: isOpen, disabled: disabled, onChange: (0, dropdownOnChange_1.dropdownOnChange)(isOpen, setIsOpen) },
            React.createElement(sok_ui_1.Button, { size: 'large', color: 'blue', disabled: disabled },
                React.createElement(sok_ui_1.Icon, { className: 'fa-chevron-down' })),
            React.createElement(sok_ui_1.Dropdown2Menu, { className: 'sok-click-wall customer-management-reports-export' },
                React.createElement(sok_ui_1.ClickWall, null,
                    React.createElement(LanguageSelect_1.LanguageSelect, { value: language, onChange: setLanguage }),
                    React.createElement(TimezoneSelect_1.TimezoneSelect, { value: timezone, onChange: setTimezone })),
                React.createElement("div", { className: 'export' },
                    React.createElement(Export_1.Export, { onClick: exportAction }))))));
};
exports.ExportReport = ExportReport;
